const domain = window.location;
let apiUrl = '';

if (domain.hostname === 'radnuk.com.ua') {
  apiUrl = domain.origin;
} else {
  apiUrl = 'https://dev.radnuk.com.ua';
}

export default apiUrl;
